import ContractGenerationTractDetail from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractGenerationTractDetail';
import Owner from '../tract_detail/Owner';
import IOwner from '../IOwner';
import WIContractOwnership from '../tract_detail/WIContractOwnership';
import ContractGenerationOwnerData from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractGenerationOwnerData';
import ContractAdHocClause from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAdHocClause';
import ContractAmendment from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAmendment';
import Acknowledgement from '../leasing/Acknowledgement';
import ContractAddendumClauseXRef from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAddendumClauseXRef';
import IContract from './IContract';
import ProvisionLeaseClause from '../ProvisionLeaseClause';

export default class BatteryStorage implements IContract {
    id: number;
    contractName: string;
    dlcLeaseNumber: number;
    leaseDate?: Date;
    effectiveDate?: Date;
    volume: string;
    page: string;
    instrumentNumber: string;
    fedStateLeaseNumber: string;
    isFiledByMemo?: boolean;
    originalGrossAcres?: number;
    leasedBy: string;
    lesseeName: string;
    lesseeAddressLine1: string;
    lesseeAddressLine2: string;
    lesseeCity: string;
    lesseeState: string;
    lesseeZipCode: string;
    lesseePhoneNumber: string;
    lesseeOwnerLookupId?: number;
    originalLessee: string;
    isNotOriginalLessee?: boolean;
    lessorAka: string;
    createdDate?: Date;
    isCommitted?: boolean;
    commitDate?: Date;
    inHandDate?: Date;
    isInHand?: boolean;
    voidDate?: Date;
    isVoid?: boolean;
    createdByUserId?: number;
    leasedByUserId?: number;
    recordDate?: Date;
    recordTypeId?: number;
    recordType?: string;
    projectId?: number;
    isGeneratedLease?: boolean;
    isActive?: boolean;
    legalDescription: string;
    rteLegalDescription: string;
    leaseLessorNotes: string;
    bonusAmount?: number;
    bonusTypeId?: number;
    bonusType?: string;
    clientDocNumber: string;
    reminderDate?: Date;
    reminderNote: string;
    ownersOnDocument: string;
    ownersAddressOnDocument: string;
    ownersSSNTaxIdOnDocument: string;
    recordedDate?: Date;
    bankingDays?: number;
    bankingDaysUnit?: string;
    originalInHandDate?: Date;

    // not mapped
    invoiceableLookupId?: number;

    currentHold?: BatteryStorageHold;
    batteryStorageHolds?: Array<BatteryStorageHold>;

    adHocClauses?: Array<ContractAdHocClause>;
    removeAdHoc?: Array<number>;
    contractClauses?: Array<ContractAddendumClauseXRef>;
    contractAmendments?: Array<ContractAmendment>;
    acknowledgements?: Array<Acknowledgement>;

    tracts?: Array<ContractGenerationTractDetail>;
    owners?: Array<ContractGenerationOwnerData>;
}

export class BatteryStorageHold {
    id: number;
    batteryStorageId?: number;
    batteryStorageHoldNumber?: number;
    executionBonus?: number;
    executionBonusTypeId?: number;
    executionBonusType?: string;
    constructionPeriod?: boolean;
    constructionFee?: number;
    constructionFeeTypeId?: number;
    constructionFeeType?: string;
    constructionDetails: string;
    constructionExtensionPeriod?: boolean;
    constructionExtensionFee?: number;
    constructionExtensionFeeTypeId?: number;
    constructionExtensionFeeType?: string;
    constructionExtensionDetails: string;
    accessEasement?: boolean;
    accessFee?: number;
    accessFeeTypeId?: number;
    accessFeeType?: string;
    accessWidth?: number;
    accessWidthTypeId?: number;
    accessWidthType?: string;
    accessDetails: string;
    transmissionEasement?: boolean;
    transmissionFee?: number;
    transmissionFeeTypeId?: number;
    transmissionFeeType?: string;
    transmissionWidth?: number;
    transmissionWidthTypeId?: number;
    transmissionWidthType?: string;
    transmissionDetails: string;
    temporaryUseAreas?: boolean;
    temporaryUseFee?: number;
    temporaryUseFeeTypeId?: number;
    temporaryUseFeeType?: string;
    temporaryUseDetails: string;
    cropBuyout?: boolean;
    cropBuyoutFee?: number;
    cropBuyoutFeeTypeId?: number;
    cropBuyoutFeeType?: string;
    cropBuyoutDetails: string;
    developmentPeriod?: boolean;
    developmentPeriodTerm?: number;
    developmentPeriodTermTypeId?: number;
    developmentPeriodTermType?: string;
    developmentRentAmount?: number;
    developmentRentTermTypeId?: number;
    developmentRentTermType?: string;
    developmentPeriodExtension?: boolean;
    developmentPeriodExtensionTerm?: number;
    developmentPeriodExtensionTermTypeId?: number;
    developmentPeriodExtensionTermType?: string;
    firstExtensionOptionRentAmount?: number;
    firstExtensionOptionRentTermTypeId?: number;
    firstExtensionOptionRentTermType?: string;
    prepaidOption?: boolean;
    developmentPeriodSecondExtension?: boolean;
    developmentPeriodSecondExtensionTerm?: number;
    developmentPeriodSecondExtensionTermTypeId?: number;
    developmentPeriodSecondExtensionTermType?: string;
    secondExtensionOptionRentAmount?: number;
    secondExtensionOptionRentTermTypeId?: number;
    secondExtensionOptionRentTermType?: string;
    additionalExtensionOptions?: boolean;
    operationsPeriod?: boolean;
    operationsPeriodTerm?: number;
    operationsPeriodTermTypeId?: number;
    operationsPeriodTermType?: string;
    operationsBaseRentAmount?: number;
    operationsBaseRentTermTypeId?: number;
    operationsBaseRentTermType?: string;
    annualEscalationRate?: number;
    escalationAbovePrime?: boolean;
    overdueRateTerm?: number;
    overdueAbovePrime?: boolean;
    extendedOperationsPeriod?: boolean;
    extendedOperationsPeriodTerm?: number;
    extendedOperationsPeriodTermTypeId?: number;
    extendedOperationsPeriodTermType?: string;
    extendedOperationsRentAmount?: number;
    extendedOperationsRentTermTypeId?: number;
    extendedOperationsRentTermType?: string;
    substationArea?: boolean;
    substationAcres?: number;
    substationFee?: number;
    substationFeeTypeId?: number;
    substationFeeType?: string;
    substationDetails: string;
    restorationPeriod?: boolean;
    restorationTerm?: number;
    restorationTermTypeId?: number;
    restorationTermType?: string;
    restorationTermRentAmount?: number;
    restorationTermRentTypeId?: number;
    restorationTermRentType?: string;
    facility?: boolean;
    facilityFee?: number;
    facilityFeeTypeId?: number;
    facilityFeeType?: string;
    facilityDetails: string;
    additionalPayments?: number;
    rightsToAssign?: boolean;
    isActive?: boolean;
    isHistorical?: boolean;
    poolingOrderNumber?: string;
    hbp?: boolean;
    hbu?: boolean;
    operator?: string;
    wellName?: string;
    apiNumber?: string;
    unitName?: string;
    fieldName?: string;

    // not mapped
    totalBonusPaid: number;
    executionBonusTotal?: number;
    substationFeeTotal?: number;
    wiOwners?: Array<Owner>;
    contractOwnerships?: Array<WIContractOwnership>;
    surfaceOwner: IOwner;
    ownershipId?: number;
    contractLookupId?: number;
    sourceBatteryStorageHoldId?: number;
    provisionLeaseClauses?: Array<ProvisionLeaseClause>;
}



// WEBPACK FOOTER //
// ./src/models/contract_types/BatteryStorage.ts